import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { mapState, mapMutations } from 'vuex';
import { changeContainerStatus } from '@/views/template/containerTemplateComponent/request';
export default {
  props: {
    currentControlItem: {
      type: Object,
      default: () => {}
    },
    currentControlIndex: {
      type: Number,
      default: 0
    },
    formDataArray: {
      type: Array,
      default: () => []
    },
    isGroupItem: {
      type: Boolean,
      default: false
    },
    isGroupControl: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isHaveRelation: false,
      isCopySuccessDisplayed: false
    };
  },
  computed: {
    ...mapState('control', ['controlDatas', 'activeIdx', 'groupItemActiveIdx', 'groupSelected'])
  },
  methods: {
    ...mapMutations({
      SET_GROUP_SELECTED: 'control/SET_GROUP_SELECTED',
      SET_ACTIVE_IDX: 'control/SET_ACTIVE_IDX',
      SET_CONTROL_DATAS: 'control/SET_CONTROL_DATAS',
      SET_GROUP_ITEM_ACTIVE_IDX: 'control/SET_GROUP_ITEM_ACTIVE_IDX'
    }),
    deleteControl(index) {
      // 判断是否有关联
      this.checkRelation(this.currentControlIndex);
      if (this.isHaveRelation) {
        const that = this;
        this.$confirm({
          title: this.$t('删除控件将清除所有控件间的关联关系，是否确认清除？'),
          onOk() {
            // 清除关联
            that.clearRelationData();
            if (that.currentControlItem.partsType === 'table' && that.currentControlItem.containerTemplateId !== -1) {
              let params = {
                id: that.currentControlItem.containerTemplateId,
                status: 0
              };
              changeContainerStatus(params);
            }
            that.formDataArray.splice(index, 1);
            // 删除控件组需要移除选中状态
            if (that.currentControlItem.controlType === 'controlGroup') {
              that.SET_GROUP_SELECTED(false);
            }
          }
        });
      } else {
        if (this.currentControlItem.partsType === 'table' && this.currentControlItem.containerTemplateId !== -1) {
          let params = {
            id: this.currentControlItem.containerTemplateId,
            status: 0
          };
          changeContainerStatus(params);
        }
        this.formDataArray.splice(index, 1);
        // 删除控件组需要移除选中状态
        if (this.currentControlItem.controlType === 'controlGroup') {
          this.SET_GROUP_SELECTED(false);
        }
      }
      // if (this.currentControlItem.controlType === 'controlGroup') {
      //   this.currentControlItem.groupSelected = false;
      //   let num = 0;
      //   this.formDataArray.forEach(item => {
      //     console.log(item);
      //     if (item.controlType === 'controlGroup') {
      //       num += 1;
      //     }
      //   });
      //   console.log(num, '-------groupNum-------');
      //   if (num == 1) {
      //     this.SET_GROUP_SELECTED(false);
      //   }
      // }
    },
    canMoveUp(index) {
      return index > 0;
    },
    canMoveDown(index) {
      return index < this.formDataArray.length - 1;
    },
    moveUp(index) {
      if (index > 0) {
        // 判断是否有关联
        this.checkRelation(index);
        if (this.isHaveRelation) {
          const that = this;
          this.$confirm({
            title: this.$t('移动控件位置将清除所有控件间的关联关系，是否确认清除？'),
            onOk() {
              // 清除关联
              that.clearRelationData();
              const temp = that.formDataArray[index];
              that.$set(that.formDataArray, index, that.formDataArray[index - 1]);
              that.$set(that.formDataArray, index - 1, temp);
            }
          });
        } else {
          const temp = this.formDataArray[index];
          this.$set(this.formDataArray, index, this.formDataArray[index - 1]);
          this.$set(this.formDataArray, index - 1, temp);
        }
      }
    },
    // 查看当前控件是否有关联关系
    checkRelation(index) {
      let currentControlMark = this.formDataArray[index].mark;
      let relatedControlMark = [];
      this.formDataArray.forEach(item => {
        var _item$association;
        if ((item === null || item === void 0 || (_item$association = item.association) === null || _item$association === void 0 || (_item$association = _item$association.association) === null || _item$association === void 0 ? void 0 : _item$association.length) > 0) {
          relatedControlMark.push(item.mark);
          item.association.association.forEach(item1 => {
            relatedControlMark.push(item1.hideControl);
          });
        }
      });
      if (relatedControlMark.indexOf(currentControlMark) !== -1) {
        this.isHaveRelation = true;
      }
    },
    moveDown(index) {
      if (index < this.formDataArray.length - 1) {
        // 判断是否有关联
        this.checkRelation(index);
        if (this.isHaveRelation) {
          const that = this;
          this.$confirm({
            title: this.$t('移动控件位置将清除所有控件间的关联关系，是否继续执行？'),
            onOk() {
              // 清除关联
              that.clearRelationData();
              const temp = JSON.parse(JSON.stringify(that.formDataArray[index]));
              that.$set(that.formDataArray, index, JSON.parse(JSON.stringify(that.formDataArray[index + 1])));
              that.$set(that.formDataArray, index + 1, temp);
            }
          });
        } else {
          const temp = JSON.parse(JSON.stringify(this.formDataArray[index]));
          this.$set(this.formDataArray, index, JSON.parse(JSON.stringify(this.formDataArray[index + 1])));
          this.$set(this.formDataArray, index + 1, temp);
        }
      }
    },
    //  复制
    copyControl(index) {
      // this.itemid获取id
      // 假设审核流id为123，节点id为456，时间戳为1630218456789，控件序号为1
      //   const auditFlowId = this.itemid; //审核流id
      //   const nodeId = index; //选中index
      //   const controlIndexPadded = '0000'; //节点id
      //   //  const controlId = `d.${auditFlowId}${nodeId}control${}${controlIndexPadded}`;
      //   const controlId = `d.${auditFlowId}control${controlIndexPadded}${nodeId}`;
      //   this.formDataArray[index].mark = controlId;
      // console.log(this.formDataArray[index].mark, '-----------');
      const msg = `${'${'}${this.formDataArray[index].mark}${'}'}`;
      const save = function (e) {
        e.clipboardData.setData('text/plain', msg);
        e.preventDefault(); // 阻止默认行为
      };
      const once = {
        once: true
      };
      document.addEventListener('copy', save, once); // 添加一个copy事件,当触发时执行一次,执行完删除
      document.execCommand('copy'); // 执行copy方法

      // this.$message.success(this.$t('复制成功'));

      //复制成功只显示一次
      if (!this.isCopySuccessDisplayed) {
        this.isCopySuccessDisplayed = true;
        this.$message.success(this.$t('复制成功'));
      }
    },
    // 清除关联关系
    clearRelationData() {
      this.formDataArray.forEach(item => {
        item.association.association = [];
      });
      this.isHaveRelation = false;
    },
    editControl() {
      // 判断是否有关联
      this.checkRelation(this.currentControlIndex);
      if (this.isHaveRelation) {
        const that = this;
        this.$confirm({
          title: this.$t('编辑控件将清除所有控件间的关联关系，是否确认清除？'),
          onOk() {
            // 清除关联
            that.clearRelationData();
            that.$emit('formeClick', that.currentControlIndex, that.currentControlItem.partsType);
          }
        });
      } else {
        this.$emit('formeClick', this.currentControlIndex, this.currentControlItem.partsType);
      }
    }
  }
};